import { useLocation } from "react-router-dom"
import { matchPath } from "react-router-dom"

const usePathMatcher = () => {
  const location = useLocation()

  const newPatientsFlowMatch =
    !!matchPath("/patients/:subroute/*", location.pathname) || // dont match '/patients' page(home page)
    !!matchPath("/records/*", location.pathname)
    
  const clinicalMatch = !!matchPath(
    "/clinical/patient/:patientId/case/:caseId/*",
    location.pathname,
  )
  const orderMatch = !!matchPath(
    "/order/patient/:patientId/case/:caseId/*",
    location.pathname,
  )
  const refinementConfirmationMatch = !!matchPath(
    "/overview/patient/:patientId/case/:caseId/refinement/confirmation",
    location.pathname,
  )
  const releaseNotesMatch = matchPath("/help/releaseNotes", location.pathname)
  const helpRouteMatch = matchPath("/help/help", location.pathname)
  const uassistSubmitConfirmationMatch = matchPath("/records/patient/:patientId/case/:caseId/summary/confirmation", location.pathname)
  const isPricingPageMatch = matchPath("/billing/pricing", location.pathname)

  return {
    newPatientsFlowMatch,
    clinicalMatch,
    orderMatch,
    refinementConfirmationMatch,
    releaseNotesMatch,
    helpRouteMatch,
    uassistSubmitConfirmationMatch,
    isPricingPageMatch
  }
}

export default usePathMatcher
